import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import makeStyles from '@mui/styles/makeStyles';
import { IInfo } from './helixIcons';
import { useTranslation } from 'react-i18next';

export default function PasswordGuidelines() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Alert
      icon={<IInfo fontSize="inherit" style={{ color: '#191919' }} />}
      className={classes.passwordInfoAlert}
      severity="info"
    >
      <AlertTitle>{t('The password:')}</AlertTitle>
      <ul className={classes.passwordCriteria + ' password-policy-list'}>
        <li className={classes.listItem}>
          {t('Must include the following:')}
          <ul className={classes.nestedList}>
            <li className={classes.nestedItem}>{t('A lower case letter')}</li>
            <li className={classes.nestedItem}>{t('An upper case letter')}</li>
            <li className={classes.nestedItem}>{t('A number')}</li>
            <li className={classes.nestedItem}>
              {t('A special character e.g. #, $ etc')}
            </li>
          </ul>
        </li>
        <li>
          {t('Must be at least {{minCharLength}} characters long', {
            minCharLength: 10,
          })}
        </li>
        <li>{t("Can't contain your name")}</li>
        <li>{t("Can't contain your email address")}</li>
      </ul>
    </Alert>
  );
}

const useStyles = makeStyles(theme => ({
  passwordInfoAlert: {
    background: '#effcfb',
    border: '1px solid #66e2da',
  },
  passwordCriteria: {
    paddingLeft: '1rem',
  },
  listItem: {
    padding: '7px 3px',
  },
  nestedList: {
    paddingLeft: '1rem',
    marginLeft: 10,
    marginTop: 4,
  },
  nestedItem: {
    padding: 3,
  },
}));
